import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, addDoc, updateDoc, deleteDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { IconPlus, IconTrash } from '../components/Icons';

export default function Banners() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  // Form State
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const q = query(collection(db, 'banners'), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(q, snap => {
      setBanners(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const handleAddBanner = async (e) => {
    e.preventDefault();
    if (!title.trim()) {
      alert('कृपया बॅनरचे शीर्षक टाका.');
      return;
    }

    try {
      setSubmitting(true);
      await addDoc(collection(db, 'banners'), {
        title: title.trim(),
        subtitle: subtitle.trim(),
        imageUrl: imageUrl.trim() || null,
        active: true,
        createdAt: serverTimestamp(),
      });

      setTitle('');
      setSubtitle('');
      setImageUrl('');
      setSubmitting(false);
      alert('बॅनर यशस्वीरीत्या जोडला!');
    } catch (err) {
      setSubmitting(false);
      alert('Error: ' + err.message);
    }
  };

  const toggleActive = async (id, currentStatus) => {
    try {
      await updateDoc(doc(db, 'banners', id), { active: !currentStatus });
    } catch (err) {
      alert('Error: ' + err.message);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('हा बॅनर डिलीट करायचा आहे का?')) {
      try {
        await deleteDoc(doc(db, 'banners', id));
      } catch (err) {
        alert('Error: ' + err.message);
      }
    }
  };

  return (
    <div style={{ paddingBottom: 40 }}>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)', margin: '0 0 6px 0' }}>
          🖼️ App Banner & Slider Management (होमपेज बॅनर)
        </h2>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          मोबाईल अ‍ॅपच्या होमपेजवर दिसणारे ऑफर्सचे बॅनर आणि मेसेज इथून बदलून ऑन-ऑफ करा.
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '340px 1fr', gap: 20 }}>
        {/* Add Banner Form */}
        <div className="card" style={{ height: 'fit-content' }}>
          <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
            <IconPlus size={18} /> नवीन बॅनर जोडा
          </h3>

          <form onSubmit={handleAddBanner} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 700, display: 'block', marginBottom: 4 }}>बॅनर शीर्षक (Main Title)</label>
              <input
                type="text"
                placeholder="उदा. 🎉 पहिली २ डिलिव्हरी मोफत!"
                value={title}
                onChange={e => setTitle(e.target.value)}
                style={{ width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg)' }}
                required
              />
            </div>

            <div>
              <label style={{ fontSize: 12, fontWeight: 700, display: 'block', marginBottom: 4 }}>उप-शीर्षक / माहिती (Sub-Title)</label>
              <input
                type="text"
                placeholder="उदा. किराणा आणि जेवण आता घरपोच!"
                value={subtitle}
                onChange={e => setSubtitle(e.target.value)}
                style={{ width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg)' }}
              />
            </div>

            <div>
              <label style={{ fontSize: 12, fontWeight: 700, display: 'block', marginBottom: 4 }}>फोटो लिंक (Image URL - Optional)</label>
              <input
                type="url"
                placeholder="https://example.com/banner.jpg"
                value={imageUrl}
                onChange={e => setImageUrl(e.target.value)}
                style={{ width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg)' }}
              />
            </div>

            <button type="submit" className="btn btn-primary" disabled={submitting} style={{ marginTop: 4 }}>
              {submitting ? 'जोडत आहे...' : '🖼️ बॅनर सेव्ह करा (Save Banner)'}
            </button>
          </form>
        </div>

        {/* Banners List */}
        <div className="card">
          <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>सध्याचे बॅनर्स (Active App Banners)</h3>

          {loading ? (
            <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>लोड होत आहे...</div>
          ) : banners.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>कोणताही बॅनर जोडलेला नाही.</div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 14 }}>
              {banners.map(b => (
                <div
                  key={b.id}
                  style={{
                    borderRadius: 12, padding: 14,
                    background: b.active ? 'linear-gradient(135deg, rgba(255,107,53,0.1), rgba(255,107,53,0.02))' : 'var(--bg)',
                    border: '1px solid', borderColor: b.active ? 'var(--primary)' : 'var(--border)',
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                    <span className={`badge ${b.active ? 'success' : 'danger'}`}>
                      {b.active ? 'Showing on App' : 'Hidden'}
                    </span>
                    <button
                      onClick={() => handleDelete(b.id)}
                      className="btn btn-danger btn-sm"
                      style={{ padding: '3px 6px' }}
                    >
                      <IconTrash size={12} />
                    </button>
                  </div>

                  {b.imageUrl && (
                    <img
                      src={b.imageUrl}
                      alt={b.title}
                      style={{ width: '100%', height: 100, objectFit: 'cover', borderRadius: 8, marginBottom: 8 }}
                      onError={e => e.target.style.display = 'none'}
                    />
                  )}

                  <div style={{ fontWeight: 800, fontSize: 14, color: 'var(--text)', marginBottom: 4 }}>
                    {b.title}
                  </div>
                  {b.subtitle && <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 10 }}>{b.subtitle}</div>}

                  <button
                    onClick={() => toggleActive(b.id, b.active)}
                    className={`btn ${b.active ? 'btn-secondary' : 'btn-success'} btn-sm w-full`}
                    style={{ justifyContent: 'center' }}
                  >
                    {b.active ? 'अ‍ॅपवरून लपवा (Hide)' : 'अ‍ॅपवर दाखवा (Show)'}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
